import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadAttributes = async () => {
  try {
    const response = await Axios.get('attributes');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneAttribute = async (name) => {
  try {
    const respnse = await Axios.get('attributes/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadAttribute = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('setups/product-categories');
        // const responseData = await response.data;
        // return {...responseData, category: {}};
        return {};
        
      default:
        const data = await loadOneAttribute(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useAttributeAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('attributes', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('attribute_created', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('attributes/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('attribute_update', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useAttributeAPI;


